<template lang="pug">
  .box
    .banner
    .nav
      ul
        li(:class="[flag==1?'border-blue':'']" @click="scene")
          a(href="javascript:;") 业务场景
    <router-view></router-view>
    .nav1(v-if="flag3==true")
      ul
        li(:class="[flag==1?'border-blue':'']" @click="scene")
          a(href="javascript:;") 业务场景
</template>

<script>
export default {
  data () {
    return {
      flag: 1,
      flag3: false
    }
  },
  created () {
    this.$store.commit('changeNav', 4)
  },
  methods: {
    scene () {
      this.flag = 1
      window.scroll(0, 480)
      this.$router.push('/slution')
    },
    handle (e) {
      e = e || window.event
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          this.flag3 = false
        } else if (e.wheelDelta < 0) {
          if (this.scrollTop > 500) {
            this.flag3 = true
          } else {
            this.flag3 = false
          }
        }
      } else if (e.detail) {
        if (e.detail > 0) {
          this.flag3 = false
        } else if (e.detail < 0) {
          if (this.scrollTop > 500) {
            this.flag3 = true
          } else {
            this.flag3 = false
          }
        }
      }
    },
    handleScroll1 () {
      this.scrollTop = window.pageYOffset
    }
  },
  mounted () {
    document.title = '速云官网'
    window.addEventListener('scroll', this.handleScroll1)
    window.addEventListener('wheel', this.handle)
    window.addEventListener('DOMMouseScroll', this.handle)
    window.addEventListener('mousewheel', this.handle)
  }
}
</script>

<style lang="less" scoped>
  .banner{
    width: 100%;
    height: 386px;
    background-image: url(../../assets/img/bannerb.jpg);
    background-size: cover;
    background-position: 50%;
  }
  .nav1,.nav{
    height: 95px;
    width: 100%;
    ul{
      width: 70%;
      height: 95px;
      margin: 0 auto;
      li{
        float: left;
        width: 100px;
        margin-right: 50px;
        padding: 28px 0;
        cursor: pointer;
        a{
          font-size: 24px;
          color: #333;
        }
      }
      .border-blue{
        border-bottom: 3px solid #007BF9;
      }
    }
  }
  .nav1{
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
  }
</style>
